import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const informationPageUsersSectionAddEditUserDialogK = {
  showDekoSupportLink: "information_page_users_section_add_edit_user_dialog.showDekoSupportLink",
  profileAccess: "information_page_users_section_add_edit_user_dialog.profileAccess",
  viewProjects: "information_page_users_section_add_edit_user_dialog.viewProjects",
  inviteUserViaEmail: "information_page_users_section_add_edit_user_dialog.inviteUserViaEmail",
  inviteUserMesssage: "information_page_users_section_add_edit_user_dialog.inviteUserMesssage",
  viewInvoice: "information_page_users_section_add_edit_user_dialog.viewInvoice",
  manageOtherPublicUser: "information_page_users_section_add_edit_user_dialog.manageOtherPublicUser",
  viewPriceList: "information_page_users_section_add_edit_user_dialog.viewPriceList",
  showPictureStoreLink: "information_page_users_section_add_edit_user_dialog.showPictureStoreLink",
};

export const useInformationPageUsersSectionAddEditUserDialogT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      showDekoSupportLink: t(informationPageUsersSectionAddEditUserDialogK.showDekoSupportLink),
      profileAccess: t(informationPageUsersSectionAddEditUserDialogK.profileAccess),
      viewProjects: t(informationPageUsersSectionAddEditUserDialogK.viewProjects),
      inviteUserViaEmail: t(informationPageUsersSectionAddEditUserDialogK.inviteUserViaEmail),
      inviteUserMesssage: t(informationPageUsersSectionAddEditUserDialogK.inviteUserMesssage),
      viewInvoice: t(informationPageUsersSectionAddEditUserDialogK.viewInvoice),
      manageOtherPublicUser: t(informationPageUsersSectionAddEditUserDialogK.manageOtherPublicUser),
      viewPriceList: t(informationPageUsersSectionAddEditUserDialogK.viewPriceList),
      showPictureStoreLink: t(informationPageUsersSectionAddEditUserDialogK.showPictureStoreLink),
    }),
    [i18n.language]
  );
};